import React from 'react';

export default function CareersPage() {
  return (
    <div className="dashboard">
      <h1>Careers</h1>

      <div className="stream-setup">
        <h2>Join the Team</h2>
        <p style={{ fontSize: '0.95rem', color: '#adadb8', lineHeight: 1.7, marginBottom: '20px' }}>
          We're building the next generation of live streaming — one that actually puts creators first. If that excites you, we want to hear from you.
        </p>

        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '14px', marginBottom: '24px' }}>
          {[
            { icon: '~', label: 'Remote First', desc: 'Work from anywhere in the world' },
            { icon: '*', label: 'Small Team', desc: 'Your work has real impact from day one' },
            { icon: '<3', label: 'Creator-Focused', desc: 'Everything we build is for streamers' },
            { icon: '!', label: 'Move Fast', desc: 'Ship features, not bureaucracy' },
          ].map((v, i) => (
            <div key={i} style={{ padding: '20px', background: '#0e0e10', borderRadius: '2px', border: '1px solid #2a2a2e', boxShadow: '2px 2px 0 rgba(0,0,0,0.3)', textAlign: 'center' }}>
              <div style={{ fontFamily: 'var(--font-pixel)', fontSize: '1rem', color: 'var(--accent)', marginBottom: '10px' }}>{v.icon}</div>
              <div style={{ fontWeight: 800, fontSize: '0.95rem', marginBottom: '6px' }}>{v.label}</div>
              <div style={{ fontSize: '0.82rem', color: '#adadb8' }}>{v.desc}</div>
            </div>
          ))}
        </div>
      </div>

      <div className="stream-setup">
        <h2>Open Positions</h2>

        {[
          { title: 'Full-Stack Engineer', type: 'Engineering', location: 'Remote', tags: ['React', 'Python', 'PostgreSQL'] },
          { title: 'Community Manager', type: 'Community', location: 'Remote', tags: ['Moderation', 'Social Media', 'Streaming'] },
          { title: 'Product Designer', type: 'Design', location: 'Remote', tags: ['UI/UX', 'Figma', 'Pixel Art'] },
        ].map((job, i) => (
          <div key={i} style={{ padding: '16px', background: '#0e0e10', borderRadius: '2px', border: '1px solid #2a2a2e', boxShadow: '2px 2px 0 rgba(0,0,0,0.3)', marginBottom: '10px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}>
              <div>
                <div style={{ fontWeight: 800, fontSize: '1rem', marginBottom: '4px' }}>{job.title}</div>
                <div style={{ fontSize: '0.82rem', color: '#adadb8' }}>{job.type} · {job.location}</div>
              </div>
              <a href={`mailto:careers@ninty.live?subject=Application: ${job.title}`}
                className="btn btn-primary" style={{ textDecoration: 'none', flexShrink: 0 }}>
                Apply
              </a>
            </div>
            <div style={{ display: 'flex', gap: '6px', flexWrap: 'wrap', marginTop: '10px' }}>
              {job.tags.map(t => (
                <span key={t} style={{ padding: '2px 8px', borderRadius: '2px', fontSize: '0.72rem', fontWeight: 600, background: '#18181b', color: '#adadb8', border: '1px solid #2a2a2e' }}>
                  {t}
                </span>
              ))}
            </div>
          </div>
        ))}

        <p style={{ fontSize: '0.82rem', color: '#adadb8', marginTop: '16px' }}>
          Don't see your role? Reach out anyway — we're always looking for talented people.
        </p>
      </div>

      <div className="stream-setup">
        <h2>Contact</h2>
        <p style={{ fontSize: '0.9rem', color: '#adadb8', lineHeight: 1.6, marginBottom: '16px' }}>
          Send your resume and a note about why you want to join Ninty.
        </p>
        <a href="mailto:careers@ninty.live" className="btn btn-primary" style={{ display: 'inline-block', textDecoration: 'none' }}>
          careers@ninty.live
        </a>
      </div>
    </div>
  );
}
